import React from "react";
import path from '../../../img/partners/exantech.png'

const Exantech: React.FunctionComponent = () => (
  <img src={path}/>
)

export default Exantech
